import { render, staticRenderFns } from "./Valid-textarea.vue?vue&type=template&id=7bdecc3d&scoped=true"
import script from "./Valid-textarea.vue?vue&type=script&lang=js"
export * from "./Valid-textarea.vue?vue&type=script&lang=js"
import style0 from "./Valid-textarea.vue?vue&type=style&index=0&id=7bdecc3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdecc3d",
  null
  
)

export default component.exports